import { defineMessages } from 'react-intl';

const messages = defineMessages({
  privacyPreferences: {
    description: 'Title for the privacy preferences page',
    defaultMessage: 'Privacy Preferences',
  },
  privacyCenter: {
    description: 'Title for the privacy center page',
    defaultMessage: 'Privacy Center',
  },
  privacySettings: {
    description: 'Title for the privacy settings page',
    defaultMessage: 'Privacy Settings',
  },
  privacySettingTips: {
    description: 'tips for privacy setting',
    defaultMessage: 'You must save privacy setting changes and restart Tubi for changes to take effect.',
  },
  privacySettingUpdateModalTitle: {
    description: 'modal title for restart app',
    defaultMessage: 'Privacy Preferences Updated',
  },
  privacySettingUpdateModalDescription: {
    description: 'modal description for restart app',
    defaultMessage: 'You must restart Tubi for changes to take effect.',
  },
  privacySettingRestartButton: {
    description: 'restart app button text',
    defaultMessage: 'Restart',
  },
  privacySettingDescription: {
    description: 'Description for privacy setting',
    defaultMessage: 'You must save privacy setting changes and restart Tubi for changes to take effect.',
  },
  privacySettingButton: {
    description: 'Button for open View Privacy Settings',
    defaultMessage: 'View Privacy Settings',
  },
  required: {
    description: 'Required field for the list of consents',
    defaultMessage: 'Required',
  },
  off: {
    description: 'label for off button toggle',
    defaultMessage: 'Off',
  },
  on: {
    description: 'label for on button toggle',
    defaultMessage: 'On',
  },
  yourPrivacy: {
    description: 'Title for the privacy preferences page',
    defaultMessage: 'Your Privacy',
  },
  yourPrivacySubtitle: {
    description: 'Subtitle for the privacy preferences page',
    defaultMessage: 'Please take a moment to confirm your data privacy preferences',
  },
  managePreferences: {
    description: 'Button to manage preferences',
    defaultMessage: 'Manage Preferences',
  },
  accept: {
    description: 'Button to accept all consents',
    defaultMessage: 'Accept All',
  },
  reject: {
    description: 'Button to reject all consents',
    defaultMessage: 'Reject All',
  },
  save: {
    description: 'Button to save consents',
    defaultMessage: 'Save and Continue',
  },
  saveAndStart: {
    description: 'Button to save consents',
    defaultMessage: 'Save and Restart Tubi',
  },
  privacyPolicy: {
    description: 'Title for the privacy policy page',
    defaultMessage: 'Privacy Policy',
  },
  privacyPolicyDescription: {
    description: 'Description for the privacy policy page',
    defaultMessage: 'To view Tubi\'s Privacy Policy, scan the QR code below with your mobile device or visit {url}',
  },
  privacyPolicyDescriptionWeb: {
    description: 'Description for the privacy policy page',
    defaultMessage: 'Go view Tubi\'s Privacy Policy go to {url}',
  },
  termsOfUse: {
    description: 'Title for the terms of use',
    defaultMessage: 'Terms of Use',
  },
  termsOfUseDescription: {
    description: 'Description for the terms of use',
    defaultMessage: 'To view Tubi\'s Terms of Use, scan the QR code below with your mobile device or visit {url}',
  },
  termsOfUseDescriptionWeb: {
    description: 'Description for the terms of use',
    defaultMessage: 'Go view Tubi’s terms of use go to {url}',
  },
  dataRights: {
    description: 'Title for Data Rights section',
    defaultMessage: 'Data Rights',
  },
  dataRightsDescriptionWeb: {
    description: 'Description for Data Rights section',
    defaultMessage: 'Go view your data rights go to {url}',
  },
  dataSubjectRights: {
    description: 'Title for Data Subject Rights section',
    defaultMessage: 'Data Subject Rights',
  },
  dataSubjectRightsDescription: {
    description: 'Description for Data Subject Rights section',
    defaultMessage:
      'To view your Data Rights and complete a request, scan the QR code below with your mobile device or visit {url}',
  },
  signedUserTip: {
    description: 'The description text in the consent modal for signed users',
    defaultMessage: 'If you are signed in on another device, your preferences will update on your next session.',
  },
  visitMore: {
    description: 'The description text in the consent modal',
    defaultMessage: 'Visit {link} to learn more',
  },
  requiredToastTitle: {
    description: 'Title for the toast',
    defaultMessage: 'Setting Required',
  },
  requiredToastDescription: {
    description: 'Description for the toast',
    defaultMessage: 'Essential Functionality is necessary to continue.',
  },
  privacyPreferencesLocked: {
    description: 'Tips when user can not edit privacy preferences',
    defaultMessage: 'Privacy settings can only be changed outside Tubi Kids. Only essential data is used within Tubi Kids.',
  },
  privacyPreferencesLockedWeb: {
    description: 'Tips when user can not edit privacy preferences on web',
    defaultMessage: '{settingTitle} settings can only be changed outside Tubi Kids. Only essential data is used within Tubi Kids.',
  },
  lockedToastTitle: {
    description: 'Title for the toast',
    defaultMessage: 'Setting Locked',
  },
  lockedToastDescription: {
    description: 'Description for the toast',
    defaultMessage: 'To modify, please exit Tubi Kids.',
  },
  turnOnConsent: {
    description: 'consent voice guide',
    defaultMessage: 'Press Enter to turn it on.',
  },
  turnOffConsent: {
    description: 'consent voice guide',
    defaultMessage: 'Press Enter to turn it off.',
  },
});

export default messages;
